<template>
    <div class="row listadoDeVinculos">
          <ul>
            <li v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">
                <a v-if="contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb.length > 0 && ObtenLaRutaDeDescarga(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb).VerEnVisor" v-on:click="MostrarVisor(ObtenLaRutaDeDescarga(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb));">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                <a v-else-if="contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb.length > 0"  v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb).rutaDeCarpeta, '_self');">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                 
                <a v-else-if="contenidoDeLaPaginaWeb.Vinculo.includes('http') || contenidoDeLaPaginaWeb.Vinculo.includes('https')" :href="contenidoDeLaPaginaWeb.Vinculo" target="_blank">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                <router-link v-else :to="contenidoDeLaPaginaWeb.Vinculo">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</router-link>
            </li>
        </ul>    
    </div>
</template>

<script>
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import api from '@/../static/js/api'
  import axios from 'axios'
  import comun from "@/../static/js/comun";


export default {
    data() { 
      return {
        TIPO_ROL_DE_ARCHIVO: 1,
        enumeraciones_sicpo
        
      }
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        ObtenLaRutaDeDescarga: function(archivos) { 
         let respuesta=[];
            let rutaDeDescarga = "";

            if(archivos != null && archivos != undefined && archivos.length > 0)
                archivos.forEach(archivo => {
                    if(this.TIPO_ROL_DE_ARCHIVO == archivo.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId){
                      respuesta.rutaDeDescarga = archivo.RutaDelArchivo;
                      respuesta.rutaDeCarpeta = archivo.RutaDeArchivoCarpeta;
                      respuesta.VerEnVisor = archivo.MostrarEnVisor;
                    }
                });
              //  console.log("ruta de descarga::",respuesta)
            return respuesta;
        },
  AbrirDocumento: function(vinculo, formaDeApertura) { 
  //  console.log("VINCULOOOOOO::",vinculo)
    comun.DescargarDocumentoPDF(vinculo);
  } ,
        
      MostrarVisor: function(archivo) {
    //    console.log(archivo)
           this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor',archivo.rutaDeCarpeta);      
        },
    }
}
</script>

<style scoped>
  a {
    color: rgb(33,33,33);
    cursor: pointer;
  }

  .listadoDeVinculos a {
    font-size: 16px;
  }

  .listadoDeVinculos li {
    padding-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/ListadoDeVinculos.vue